import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

const REMOVE_FROM_ALLOCATION_MUTATION = gql`
  mutation removeFromAllocationMutation($id: ID!) {
    removeFromAllocation(id: $id) {
      id
      priorityTaskAllocations {
        id
        priorityTask {
          id
          name
          isDone
        }
        allocatedUser {
          ...SimpleUserFragment
        }
      }
    }
  }
  ${SIMPLE_USER_FRAGMENT}
`

export default REMOVE_FROM_ALLOCATION_MUTATION
